import { motion } from "motion/react";
import { ShoppingCart, FileText, Package, IndianRupee } from "lucide-react";
import { cn } from "../ui/utils";
import { stripCurrencySymbolPrefix } from "../../../lib/currency";
import type { ActivityFeedItem } from "./mapRecentActivityFeed";

const iconMap = {
  sale: ShoppingCart,
  invoice: FileText,
  order: Package,
};

const colorMap = {
  sale: "bg-emerald-100 text-emerald-600",
  invoice: "bg-blue-100 text-blue-600",
  order: "bg-purple-100 text-purple-600",
};

export function ActivityFeedRow({
  activity,
  index,
  delay = 0,
}: {
  activity: ActivityFeedItem;
  index: number;
  delay?: number;
}) {
  const Icon = iconMap[activity.type];
  return (
    <motion.div
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.3, delay: delay + index * 0.05 }}
      whileHover={{ x: 4 }}
      className="flex items-start gap-3 p-3 rounded-lg hover:bg-accent transition-colors cursor-pointer"
    >
      <div
        className={cn(
          "w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0",
          colorMap[activity.type],
        )}
      >
        <Icon className="w-5 h-5" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-start justify-between gap-2">
          <div className="flex-1">
            <p className="font-medium text-sm text-foreground">{activity.title}</p>
            <p className="text-xs text-muted-foreground mt-0.5">{activity.description}</p>
            <p className="text-xs text-muted-foreground mt-1">{activity.time}</p>
          </div>
          {activity.amount ? (
            <div className="flex items-center gap-1 text-emerald-600 font-semibold text-sm">
              <IndianRupee className="w-3 h-3" />
              {stripCurrencySymbolPrefix(activity.amount)}
            </div>
          ) : null}
        </div>
      </div>
    </motion.div>
  );
}
